import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { inject } from "mobx-react";
import Container from "reactstrap/lib/Container";
import { useQuery } from "@apollo/client";
import { TARIFF_IN_ANTI_FILTER } from "Services/queries";
import { pipe } from "Utils/functionalUtils";
import { StubAntiFilter } from "ComponentsUI/Stub";
import { FilterAntiFilter } from "ComponentsUI/Filters";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";

const AntiFilterContainer = (props) => {
	const {
		ApplicationModel: { text, isAntifilterTariffId, currentRegion },
		match: {
			params: { regionUrl },
		},
		ApplicationModel,
	} = props;
	const [providerId, setProviderId] = useState(null);
	const [fixProvider, setFixProvider] = useState(false);
	const [priceTariff, setPriceTariff] = useState(null);
	const [fixPrice, setFixPrice] = useState(false);
	const [callsTariff, setCallsTariff] = useState(null);
	const [fixCalls, setFixCalls] = useState(false);
	const [internetTariff, setInternetTariff] = useState(null);
	const [fixInternet, setFixInternet] = useState(false);
	const [switchTariff, setSwitchTariff] = useState(null);

	const getFix = () => {
		let arrFixName = ["provider", "internet", "calls", "price"];
		let objFixState = {
			provider: fixProvider,
			internet: fixInternet,
			calls: fixCalls,
			price: fixPrice,
		};
		let result = "";
		arrFixName.forEach((state) => {
			if (objFixState[state] === true) {
				if (result.length > 0) {
					result += `&${state}`;
				} else {
					result += state;
				}
			}
		});
		return result;
	};
	const fix = getFix();

	const {
		loading: loadTariff,
		error: errorTariff,
		data: tariffData,
		previousData: tariffPreviousData,
	} = useQuery(TARIFF_IN_ANTI_FILTER, {
		variables: {
			id: isAntifilterTariffId,
			region: regionUrl ? regionUrl : currentRegion.url,
			providerJoin: true,
			with_aggregate: true,
			providerId: providerId,
			internet: internetTariff,
			fix: fix,
			price: priceTariff,
			switch: switchTariff,
			calls: callsTariff,
		},
		skip: false,
		notifyOnNetworkStatusChange: true,
		nextFetchPolicy: "network-only",
	});

	useEffect(() => {
		if (Boolean(tariffData?.tariffInAntiFilter?.data?.id)) {
			ApplicationModel.setIsAntifilterTariffId(tariffData.tariffInAntiFilter.data.id);
		}
	}, [loadTariff]);

	if (errorTariff) return null;

	let resp = null;

	if (tariffData?.tariffInAntiFilter?.data) {
		resp = tariffData.tariffInAntiFilter;
	} else if (tariffPreviousData?.tariffInAntiFilter?.data) {
		resp = tariffPreviousData.tariffInAntiFilter;
	}

	if (loadTariff && !resp) {
		return <StubAntiFilter />;
	}

	if (!resp) {
		return (
			<Container>
				<EmptyStubWrapper
					headerText={text.NO_OPERATORS_HEADER}
					displayText={text.no_operator_info}
					buttonText={text.TO_MAIN_PAGE}
					iconHeader={"icon-balance"}
					iconButton={"icon-playlist-add"}
				/>
			</Container>
		);
	}

	function FindIndex(arr, curValue) {
		let result;
		const length = arr.length;
		const curIndex = arr.findIndex((el) => el == curValue);
		if (curIndex === -1) {
			return null;
		}
		if (length === 1) {
			result = [null, arr[0], null];
			return result;
		} else if (length === 2) {
			if (curIndex === 0) {
				result = [null, arr[0], arr[1]];
				return result;
			} else {
				result = [arr[0], arr[1], null];
				return result;
			}
		} else {
			if (curIndex === length - 1) {
				result = [arr[curIndex - 1], arr[curIndex], null];
				return result;
			} else if (curIndex === 0) {
				result = [null, arr[curIndex], arr[curIndex + 1]];
				return result;
			} else {
				result = [arr[curIndex - 1], arr[curIndex], arr[curIndex + 1]];
				return result;
			}
		}
	}
	let tariff = resp.data;
	let nameTariff = tariff?.name;
	let socialData = tariff?.social_unlim;
	let actions =
		tariff?.after?.data?.price?.license_fee_month &&
		tariff?.after?.data?.price?.license_fee_month !== tariff.price.license_fee;
	let actionDody = tariff.dody[4].state === 1;

	let logoOperator = tariff?.provider?.logo ? tariff.provider.logo : null;

	const calls = tariff?.mobile_new?.calls ? tariff?.mobile_new?.calls : null;

	let arrCalls = resp.aggregationTariffs?.calls;

	let arrCallsButton = FindIndex(arrCalls, calls);

	const internet = tariff?.mobile_new?.internet ? tariff.mobile_new.internet : null;

	let arrInternet = resp.aggregationTariffs?.internet;

	let arrInternetButton = FindIndex(arrInternet, internet);

	const price = tariff?.displayPrice ? tariff.displayPrice : null;

	let arrPrice = resp.aggregationTariffs?.price;

	let arrPriceButton = FindIndex(arrPrice, price);

	const operatorId = tariff?.provider?.id ? tariff.provider.id : null;

	let arrOperatorsId = resp.aggregationTariffs?.providers
		? resp.aggregationTariffs.providers.map((el) => {
				return el.id;
			})
		: null;

	let arrOperotorsButton = FindIndex(arrOperatorsId, operatorId);

	return (
		<FilterAntiFilter
			nameTariff={nameTariff}
			socialData={socialData}
			text={text}
			ApplicationModel={ApplicationModel}
			logoOperator={logoOperator}
			providerName={tariff?.provider?.name}
			tariff={tariff}
			arrCallsButton={arrCallsButton}
			arrInternetButton={arrInternetButton}
			arrPriceButton={arrPriceButton}
			arrOperotorsButton={arrOperotorsButton}
			providerId={providerId}
			setProviderId={setProviderId}
			setPriceTariff={setPriceTariff}
			priceTariff={priceTariff}
			setCallsTariff={setCallsTariff}
			setInternetTariff={setInternetTariff}
			setSwitchTariff={setSwitchTariff}
			fixProvider={fixProvider}
			setFixProvider={setFixProvider}
			fixPrice={fixPrice}
			setFixPrice={setFixPrice}
			fixCalls={fixCalls}
			setFixCalls={setFixCalls}
			fixInternet={fixInternet}
			setFixInternet={setFixInternet}
			internet={internet}
			calls={calls}
			price={price}
			arrCalls={arrCalls}
			arrPrice={arrPrice}
			arrInternet={arrInternet}
			isLoading={loadTariff}
			actions={actions || actionDody}
		/>
	);
};

export default pipe(inject("ApplicationModel"), withRouter)(AntiFilterContainer);
